'use strict';

var DataRetrieverCodeDefaults = function DataRetrieverCodeDefaults(constants) {
  return [
  // alerts retrievers
  {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_PRODUCT_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_SERVICE_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_CABIN_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_CLASS_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_SEGMENT_CLASS_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.MARKET_SERVICE_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SERVICE_MANAGEMENT_ALERTS,
    cacheRawData: false
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_SUMMARY
  },
  // applicable seasons
  {
    screen: constants.MARKET_SCREEN,
    mode: constants.APPLICABLE_SEASONS,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.APPLICABLE_SEASONS,
    cacheRawData: true,
    noScenario: true
  },
  // other retrievers
  {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    isQueryingMoreDomains: true,
    pageLimit: 3000,
    dynamicPageLimit: true,
    threadsQuantity: 4
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.SERVICE_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_PRODUCT_GROUP_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    isQueryingMoreDomains: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true,
    /**
     * Search Rules Transformers:
     *  nameOfTheTransformer: [...arguments]
     */
    searchRulesTransformConfig: {
      mergeDateRules: [[{
        category: 'Time & Date',
        field: 'departureDate',
        metaCategory: 'departureDate',
        criterion: ''
      }]]
    }
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_PRODUCT_GROUP_PROFILE_GRAPH_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.SERVICE_SHARE_MODE,
    cacheRawData: false
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.SERVICE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    isQueryingMoreDomains: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.SERVICE_COMPETITOR_FARE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_PRODUCT_COMPETITOR_FARE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_COMPETITOR_FARE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.BOOKING_MATRIX_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.ADJUSTMENT_HISTORY_MODE,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.CABIN_DEEP_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CABIN_DEEP_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CABIN_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CABIN_DA_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CABIN_POST_DEPARTURE_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_CLASS_PROFILE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CLASS_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    pageLimit: 3000,
    softLimit: 5000,
    maxLimit: 20000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.FLIGHT_CABIN_PROFILE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CABIN_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SERVICE_BOOKINGS_INTAKE_MODE,
    targetType: constants.BOOKINGS_INTAKE_MODAL,
    isTriggeredBySearch: false,
    cacheRawData: true,
    noScenario: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.CLASS_POST_DEPARTURE_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 3000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SEGMENT_CLASS_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    pageLimit: 5000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SEGMENT_CLASS_POST_DEPARTURE_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 5000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SERVICE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.SERVICE_POST_DEPARTURE_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 5000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.BOOKING_MATRIX_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.FLIGHT_SCREEN,
    mode: constants.MARKET_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.STRATEGY_SCREEN,
    mode: constants.STRATEGY_LISTING_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.RULE_SCREEN,
    mode: constants.RULE_LISTING_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.RULE_SCREEN,
    mode: constants.RULE_CUSTOM_STRATEGY_LISTING,
    isTriggeredBySearch: false
  }, {
    screen: constants.SCHEDULE_CHANGE_SCREEN,
    mode: constants.SPONSOR_FORECAST_MARKET_MODE,
    isTriggeredBySearch: false,
    sortBy: 'values.departureDate',
    sortOrder: 'ASC'
  }, {
    screen: constants.SCHEDULE_CHANGE_SCREEN,
    mode: constants.SPONSOR_FORECAST_LEG_MODE,
    isTriggeredBySearch: false,
    sortBy: 'legs.departureDate',
    sortOrder: 'ASC'
  }, {
    screen: constants.SCHEDULE_CHANGE_SCREEN,
    mode: constants.SPONSOR_FORECAST_FLIGHT_MODE,
    ignoredErrorStatuses: [404]
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE,
    targetType: constants.DTD_CHART,
    isTriggeredBySearch: false,
    sortBy: 'departureDate',
    sortOrder: 'ASC,ASC',
    cacheRawData: true
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE,
    targetType: constants.DTD_MATRIX,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE,
    targetType: constants.ALL_DATA,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_INITIAL_FORECAST_PROFILE,
    targetType: constants.DTD_FORECAST_PROFILE_CHART,
    isTriggeredBySearch: false,
    cacheRawData: true,
    ignoredErrorStatuses: [404]
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR,
    targetType: constants.DTD_FORECAST_PROFILE_CHART,
    sortBy: 'departureDate',
    sortOrder: 'ASC,ASC',
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED,
    targetType: constants.DTD_FORECAST_PROFILE_CHART,
    sortBy: 'departureDate',
    sortOrder: 'ASC,ASC',
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR,
    targetType: constants.FORECAST_DATA,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DEMAND_TRANSPARENCY_SCREEN,
    mode: constants.DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED,
    targetType: constants.FORECAST_DATA,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DATA_EXTRACT_SCREEN,
    mode: constants.SCHEDULED_MODE,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.DATA_EXTRACT_SCREEN,
    mode: constants.COMPLETED_MODE,
    isTriggeredBySearch: false,
    cacheRawData: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_FLIGHT_SENT_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_SERVICE_SENT_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_FIGHT_REOPT_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_FARES_REOPT_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_HISTORY_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_ENTITY_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_MARKET_ASSIGN_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_REOPTIMIZATION_STATUS_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_HOST_SHARE_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_OVERBOOKING_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_INTERFACE_STATUS_MODE,
    isTriggeredBySearch: false,
    passByRules: [{
      criteriaName: 'Received/Sent',
      fieldName: 'custom:createdDate:creationDate',
      categoryName: 'Interface Status'
    }]
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_MODE,
    cacheRawData: true
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_AVERAGE_MODE,
    cacheRawData: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_PREV_AVERAGE_MODE,
    cacheRawData: true,
    isTriggeredBySearch: false
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.MAPPED_FARES_MODE,
    cacheRawData: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.CONTRIBUTING_SERVICES_MODE,
    cacheRawData: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.SURCHARGE_UPLOAD_MODE,
    cacheRawData: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_BASIS_GROUPS_MODE,
    cacheRawData: true,
    pageLimit: 3000
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_INTERLINE_FARES_ADJUSTMENT,
    cacheRawData: true,
    pageLimit: 3000
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_INVERSION_MODE,
    cacheRawData: false
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.MAPPED_FARES_INVERSION_MODE,
    cacheRawData: false
  }, {
    screen: constants.FARES_SCREEN,
    mode: constants.FARES_CHART_MODE,
    cacheRawData: true,
    isTriggeredBySearch: false
  }, {
    screen: constants.DASHBOARD_SCREEN,
    mode: constants.MARKET_DASHBOARD_MODE,
    cacheRawData: true,
    isQueryingMoreDomains: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.DASHBOARD_SCREEN,
    mode: constants.FIM_DASHBOARD_MODE,
    cacheRawData: true,
    isTriggeredBySearch: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_DEMAND_MODE,
    cacheRawData: false
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_POOLED_MODE,
    cacheRawData: false
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_ANALYSIS_CHART_HISTORICAL,
    cacheRawData: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED,
    cacheRawData: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_ANALYSIS_CHART_FUTURE,
    cacheRawData: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_ANALYSIS_CHART_FUTURE_POOLED,
    cacheRawData: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_OFFLINE_CALENDAR_REVIEW,
    cacheRawData: true
  }, {
    screen: constants.SEASONALITY_SCREEN,
    mode: constants.SEASONALITY_UNTRUNCATED_MD_MODE,
    cacheRawData: false
  }, {
    screen: constants.ROM_ANALYSIS_SCREEN,
    mode: constants.ROM_ANALYSIS_LOCO_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 60000,
    threadsQuantity: 2,
    dynamicPageLimit: true
  }, {
    screen: constants.ROM_ANALYSIS_SCREEN,
    mode: constants.ROM_ANALYSIS_DEMAND_PAX_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 60000,
    threadsQuantity: 2,
    dynamicPageLimit: true
  }, {
    screen: constants.ROM_ANALYSIS_SCREEN,
    mode: constants.ROM_ANALYSIS_FLATTENED_SERVICES_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    pageLimit: 4000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.ROM_ANALYSIS_SCREEN,
    mode: constants.ROM_ANALYSIS_SKINNY_SERVICES_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    pageLimit: 4000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.ROM_ANALYSIS_SCREEN,
    mode: constants.ROM_ANALYSIS_SKINNY_SERVICES_REFERENCE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    pageLimit: 4000,
    threadsQuantity: 4,
    dynamicPageLimit: true
  }, {
    screen: constants.ROM_SUMMARY_SCREEN,
    mode: constants.ROM_SUMMARY_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true,
    httpMethod: constants.HTTP_METHOD.POST,
    mimeType: constants.MIME_TYPE.FORM_URLENCODED
  }, {
    screen: constants.ROM_SUMMARY_SCREEN,
    mode: constants.ROM_SUMMARY_REFERENCE_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true,
    httpMethod: constants.HTTP_METHOD.POST,
    mimeType: constants.MIME_TYPE.FORM_URLENCODED
  }, {
    screen: constants.ROM_SUMMARY_SCREEN,
    mode: constants.ROM_SUMMARY_TOP_OPP_RECAP_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true
  }, {
    screen: constants.ROM_SUMMARY_SCREEN,
    mode: constants.ROM_SUMMARY_TOP_OPP_SPILL_MODE,
    isTriggeredBySearch: true,
    cacheRawData: true
  }, {
    screen: constants.USER_MANAGEMENT_SCREEN,
    mode: constants.USER_MANAGEMENT_MANAGE_USERS_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.USER_MANAGEMENT_SCREEN,
    mode: constants.USER_MANAGEMENT_ROLE_MANAGEMENT_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.USER_MANAGEMENT_SCREEN,
    mode: constants.USER_MANAGEMENT_ROLES_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.USER_MANAGEMENT_SCREEN,
    mode: constants.USER_MANAGEMENT_MANAGE_ACCESS_REQUESTS_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.USER_MANAGEMENT_SCREEN,
    mode: constants.USER_MANAGEMENT_DEFAULT_ROLE_VIEW_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.PRICING_ANALYSIS_SCREEN,
    mode: constants.PRICING_ANALYSIS_DEPARTURE_DATES,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.PRICING_ANALYSIS_SCREEN,
    mode: constants.PRICING_ANALYSIS_SERVICES,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.PRICING_SUMMARY_SCREEN,
    mode: constants.PRICING_SUMMARY_SNAPSHOT_DATES,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.PRICING_SUMMARY_SCREEN,
    mode: constants.PRICING_SUMMARY_FARE_CHANGE,
    isTriggeredBySearch: false
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_PRODUCT_GROUP_MAPPED_BOOKINGS_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.MARKET_SCREEN,
    mode: constants.MARKET_MAPPED_BOOKINGS_MODE,
    isTriggeredBySearch: false,
    cacheRawData: true
  }, {
    screen: constants.SYSTEM_STATUS_SCREEN,
    mode: constants.SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_MODE,
    isTriggeredBySearch: true
  }, {
    screen: constants.CALIBRATION_ANALYSIS_SCREEN,
    mode: constants.DEMAND_SHARES_MODE,
    isTriggeredBySearch: false
  }, {
    screen: constants.ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN,
    mode: constants.ONLINE_LOGIT_CALIBRATION_MODE,
    isTriggeredBySearch: false
  }];
};
DataRetrieverCodeDefaults.$inject = ['DataRetrieverConstantsService'];
module.exports = DataRetrieverCodeDefaults;